/* eslint-disable unused-imports/no-unused-imports */

import useEmblaCarousel from "embla-carousel-react"
import {useCallback, useEffect} from "react"
import {useDispatch} from "react-redux"
import {breakpoints} from "@next/themes"

import {Action} from "@reduxjs/toolkit"
import {setAnimateFavouriteIcon, setSelectedColourwayAction} from "../../ducks/productSummary"
import useMediaQuery from "../useMediaQuery"

const useCarousel = ({textAlignment, colourways}) => {
    const dispatch = useDispatch()
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: false,
        align: "start",
        // watchDrag: !useMediaQuery(`(min-width:${breakpoints.values.lg}px)`),
        watchDrag: true,
        containScroll: false,
        direction: textAlignment === "ltr" ? "ltr" : "rtl",
        duration: 10,
        skipSnaps: false,
    })

    const [thumbsEmblaRef, thumbsEmblaApi] = useEmblaCarousel({
        loop: false,
        align: "start",
        watchDrag: true,
        containScroll: "keepSnaps",
        direction: textAlignment === "ltr" ? "ltr" : "rtl",
        skipSnaps: true,
        duration: 10,
    })

    const slideIndex = useCallback((index: number) => emblaApi?.scrollTo(index), [emblaApi])

    const thumbsSlideIndex = useCallback((index: number) => thumbsEmblaApi?.scrollTo(index), [thumbsEmblaApi])

    const handleSetSelectedColourway = (colourWayId: string) => {
        dispatch<Action>(setSelectedColourwayAction(colourWayId))
        dispatch<Action>(setAnimateFavouriteIcon(false))
    }

    useEffect(() => {
        // window.requestIdleCallback(() => {
        const handleProductSlideChange = (actualIndex: number) => {
            const currentSlide = colourways[actualIndex] || 0
            if (currentSlide) {
                handleSetSelectedColourway(currentSlide.id)
            }
        }

        if (emblaApi) {
            const handleSelect = () => {
                const selectedIndex = emblaApi.selectedScrollSnap() % colourways.length
                handleProductSlideChange(selectedIndex)
                if (thumbsEmblaApi) {
                    thumbsEmblaApi.scrollTo(selectedIndex)
                }
            }
            handleSelect()
            emblaApi.on("select", handleSelect)
            window.addEventListener("resize", handleSelect)
        }
        // })
    }, [emblaApi, colourways?.length, thumbsEmblaApi])

    return {
        emblaRef,
        emblaApi,
        slideIndex,
        thumbsEmblaRef,
        thumbsEmblaApi,
        thumbsSlideIndex,
    }
}

export default useCarousel
